import { Button, ButtonsAssignment
       } from 'app/dialogs/dialog-buttons.component';

export abstract class ErrorBase implements Error
{
  private _message: string = undefined;
  private _reference: Array<string> = [];
  protected _name: string = 'Error';
  protected _closeable: boolean;
  protected _buttons: ButtonsAssignment = {};

  public title: string;
  public text: string;

  public constructor(message: string|undefined = undefined,
                     reference: Array<string> = [],
                     closeable: boolean = true)
  {
    this._message = message;
    this._reference = reference;
    this._closeable = closeable;
    if (closeable) {
      this._buttons = { primary: Button.OK };
    }
  }

  public get message(): string
  {
    return this._message;
  }

  public set message(message: string)
  {
    this._message = message;
  }

  public get reference(): Array<string>
  {
    return this._reference;
  }

  public set reference(reference: Array<string>)
  {
    this._reference = reference;
  }

  public get name(): string
  {
    return this._name;
  }

  public get closeable(): boolean
  {
    return this._closeable;
  }

  public get buttons(): ButtonsAssignment
  {
    return this._buttons;
  }
}
(<any>Object).setPrototypeOf(ErrorBase.prototype, Error.prototype);

export class CriticalError extends ErrorBase
{
  protected _name: string = 'CriticalError';
}

export class TrivialError extends ErrorBase
{
  protected _name: string = 'TrivialError';
}
